import { Outlet } from "@remix-run/react";
import type { LoaderFunction } from "@remix-run/server-runtime";
import { redirect } from "@remix-run/server-runtime";
import DefaultLayout from "~/ui/DefaultLayout";
import ROUTES from "~/kernel/routing/ROUTES";
import isSubscriptionCancelled from "~/subscriptions/helpers/isSubscriptionCancelled";
import isNil from "~/kernel/validation/isNil";
import companyRepository from "~/repositories/companyRepository";
import { sessionReplayHandle } from "~/kernel/telemetry/sessionReplayHandle";

export const handle = sessionReplayHandle();

export const loader: LoaderFunction = async ({ params, request }) => {
  const slug = params.slug;

  if (isNil(slug)) {
    return redirectToNotFound(request, slug);
  }

  const company = await companyRepository.findBySlug(slug);

  if (isNil(company)) {
    return redirectToNotFound(request, slug);
  }

  if (isSubscriptionCancelled(company)) {
    return redirect(ROUTES.companyCancelledSubscription.path());
  }

  return null;
};

export default function CompaniesSlugPage() {
  return (
    <DefaultLayout>
      <Outlet />
    </DefaultLayout>
  );
}

function redirectToNotFound(request: Request, slug: string | undefined) {
  if (request.url.includes("not-found")) {
    return null;
  }

  if (isNil(slug)) {
    return redirect(ROUTES.companyNotFound.path({ slug: "missing-slug" }));
  }

  return redirect(ROUTES.companyNotFound.path({ slug }));
}
